module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p1-ec7dd90ffe52172a7af624024ad8a3c6.png";